import { array, number, object, string } from 'yup'

export const directSiteSchema = searchID => object({
	...!searchID && { officePickupID: number().required('Offices is required') },
	currency: string().required('Currency is required'),
	dates: string().required('Must provide a date'),
})